export default __webpack_public_path__ + "video/static/media/brain-be-turning.8b1eece1.mp4";